const Divider = ({ className }: { className?: string }) => {
  return <div className={`w-full h-px bg-[#27272A] ${className}`}></div>;
};

export default Divider;
